interface WeChatModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function WeChatModal({ isOpen, onClose }: WeChatModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-fadeIn">
      <div 
        className="absolute inset-0" 
        onClick={onClose}
      ></div>
      
      <div className="relative bg-white rounded-3xl shadow-2xl max-w-md w-full animate-slideUp overflow-hidden">
        {/* 头部 */}
        <div className="bg-gradient-to-r from-green-500 to-green-600 text-white px-8 py-6 relative">
          <button
            onClick={onClose}
            className="absolute top-6 right-6 w-10 h-10 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/30 transition-all cursor-pointer group"
          >
            <i className="ri-close-line text-2xl group-hover:rotate-90 transition-transform duration-300"></i>
          </button>
          <div className="flex items-center">
            <div className="w-14 h-14 flex items-center justify-center bg-white/20 rounded-2xl mr-4 backdrop-blur-sm">
              <i className="ri-wechat-fill text-3xl"></i>
            </div>
            <div>
              <h3 className="text-2xl font-bold mb-1">微信联系我们</h3>
              <p className="text-white/90 text-sm">扫码添加企业微信</p>
            </div>
          </div>
        </div>

        {/* 内容 */}
        <div className="p-8">
          {/* 二维码区域 */}
          <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl p-8 mb-6">
            <div className="bg-white rounded-xl p-6 shadow-lg mx-auto w-fit">
              <div className="w-56 h-56 bg-gradient-to-br from-green-100 to-green-200 rounded-lg flex items-center justify-center">
                <div className="text-center">
                  <i className="ri-qr-code-line text-6xl text-green-600 mb-3"></i>
                  <p className="text-sm text-gray-600 font-medium">微信二维码</p>
                  <p className="text-xs text-gray-500 mt-2">请使用微信扫描</p>
                </div>
              </div>
            </div>
          </div>

          {/* 提示信息 */}
          <div className="space-y-4">
            <div className="flex items-start bg-green-50 border-2 border-green-200 rounded-xl p-4">
              <div className="w-10 h-10 flex items-center justify-center bg-green-500 rounded-xl mr-3 flex-shrink-0">
                <i className="ri-smartphone-line text-white text-lg"></i>
              </div>
              <div>
                <h4 className="font-bold text-gray-900 mb-1">扫码添加企业微信</h4>
                <p className="text-sm text-gray-600 leading-relaxed">
                  使用微信扫描上方二维码，添加我们的企业微信，获取专业咨询服务
                </p>
              </div>
            </div>

            <div className="flex items-start bg-blue-50 border-2 border-blue-200 rounded-xl p-4">
              <div className="w-10 h-10 flex items-center justify-center bg-blue-500 rounded-xl mr-3 flex-shrink-0">
                <i className="ri-customer-service-2-line text-white text-lg"></i>
              </div>
              <div>
                <h4 className="font-bold text-gray-900 mb-1">7×24小时在线服务</h4>
                <p className="text-sm text-gray-600 leading-relaxed">
                  我们的专业团队随时为您解答产品咨询、技术支持等问题
                </p>
              </div>
            </div>

            <div className="flex items-start bg-purple-50 border-2 border-purple-200 rounded-xl p-4">
              <div className="w-10 h-10 flex items-center justify-center bg-purple-500 rounded-xl mr-3 flex-shrink-0">
                <i className="ri-gift-line text-white text-lg"></i>
              </div>
              <div>
                <h4 className="font-bold text-gray-900 mb-1">专属优惠活动</h4>
                <p className="text-sm text-gray-600 leading-relaxed">
                  添加企业微信，第一时间获取最新产品动态和专属优惠信息
                </p>
              </div>
            </div>
          </div>

          {/* 其他联系方式 */}
          <div className="mt-6 pt-6 border-t-2 border-gray-100">
            <p className="text-sm text-gray-600 text-center mb-3 font-semibold">其他联系方式</p>
            <div className="flex justify-center space-x-6">
              <div className="text-center">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-teal-500 to-blue-500 rounded-xl mx-auto mb-2">
                  <i className="ri-phone-line text-white text-xl"></i>
                </div>
                <p className="text-xs text-gray-600 font-medium">客服热线</p>
                <p className="text-xs text-gray-500 mt-1">18123952850</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-purple-500 to-pink-500 rounded-xl mx-auto mb-2">
                  <i className="ri-mail-line text-white text-xl"></i>
                </div>
                <p className="text-xs text-gray-600 font-medium">电子邮箱</p>
                <p className="text-xs text-gray-500 mt-1">18123952850@139.com</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
